import { zonedTimeToUtc } from 'date-fns-tz';

const defaultTimezone = 'America/New_York';

export function convertToUtc(date: Date, timezone = defaultTimezone) {
  return zonedTimeToUtc(date, timezone);
}
